import { entitiesUtils } from '../../../entities/entitiesUtils-sidecar'
import { EVoyageWaveType, IVoyageMissionWave } from './voyageMissionDataWaves'
import { voyageMissionDataWaves } from './voyageMissionDataWaves-sidecar'
import { voyageMission_null } from './voyageMission_null-sidecar'
import { voyageMission_test } from './voyageMission_test-sidecar'
import { voyageMission_waves } from './voyageMission_waves-sidecar'

const label = 'mission-data'

export type TGenMission = () => Generator<number, number, number>
export function* generator_mission_null(): Generator<number, number, number> {
  return 0
}

export enum EVoyageMissionCategory {
  Default = -1,
  Null = 0,
  Survey = 1,
  FightAliens = 2,
  FightAlienShip = 3,
  CombatZone = 4,
  Test = 5,
  Starbase = 6,
  Hyperspace = 7,
}

export enum EVoyageMissionType {
  Default = -1,
  Null = 0,
  Hyperspace,
  Starbase,
  SurveySun1,
  SurveySun2,
  SurveySun3,
  SurveyAnomaly,
  FightAliens1,
  FightAliens2,
  FightAliens3,
  FightAlienShip1,
  FightAlienShip2,
  FightAlienShip3,
  CombatZone1,
  Test1,
}

export interface IVoyageMissionData {
  type: EVoyageMissionType
  category: EVoyageMissionCategory
  name: string
  numAliens: number
  scanTime: number
  genMission: TGenMission
  genWaves: () => IVoyageMissionWave[]
}

const _default: IVoyageMissionData = {
  type: EVoyageMissionType.Default,
  category: EVoyageMissionCategory.Default,
  name: 'default',
  numAliens: 0,
  scanTime: 0,
  genMission: voyageMission_null.generator_mission_null,
  genWaves: () => [],
}

let dataList: IVoyageMissionData[] = []
let dataMap: { [key: number]: IVoyageMissionData } = {}
export function register(data: Partial<IVoyageMissionData>) {
  return entitiesUtils.genericRegisterDataNum(
    label,
    data,
    _default,
    dataList,
    dataMap,
  )
}

export function find(type: EVoyageMissionType) {
  return entitiesUtils.genericGetDataNum(label, dataMap, type)
}

export function registerAll() {
  register({
    type: EVoyageMissionType.Null,
    category: EVoyageMissionCategory.Null,
    name: 'Null Mission',
  })

  register({
    type: EVoyageMissionType.Hyperspace,
    category: EVoyageMissionCategory.Hyperspace,
    name: 'Hyperspace',
  })

  register({
    type: EVoyageMissionType.Test1,
    category: EVoyageMissionCategory.Test,
    name: 'Dev Test 1',
    genMission: voyageMission_test.generator_mission_test,
    // scanTime: 90,
  })

  register({
    type: EVoyageMissionType.Starbase,
    category: EVoyageMissionCategory.Starbase,
    name: 'Starbase',
  })

  // TODO: add different ship types
  register({
    type: EVoyageMissionType.FightAlienShip1,
    category: EVoyageMissionCategory.FightAlienShip,
    name: 'Destroy Alien Squid Ship',
    genMission: voyageMission_waves.generator_mission_waves,
    genWaves: () => {
      let waves: IVoyageMissionWave[] = []
      waves.push(
        voyageMissionDataWaves.create(EVoyageWaveType.AlienShip, {
          amount: 1,
        }),
      )
      return waves
    },
  })
  register({
    type: EVoyageMissionType.FightAlienShip2,
    category: EVoyageMissionCategory.FightAlienShip,
    name: 'Destroy Alien Hammerhead Ship',
    genMission: voyageMission_waves.generator_mission_waves,
    genWaves: () => {
      let waves: IVoyageMissionWave[] = []
      waves.push(
        voyageMissionDataWaves.create(EVoyageWaveType.AlienShip, {
          amount: 1,
        }),
      )
      return waves
    },
  })
  register({
    type: EVoyageMissionType.FightAlienShip3,
    category: EVoyageMissionCategory.FightAlienShip,
    name: 'Destroy Alien Juggernaut Ship',
    genMission: voyageMission_waves.generator_mission_waves,
    genWaves: () => {
      let waves: IVoyageMissionWave[] = []
      waves.push(
        voyageMissionDataWaves.create(EVoyageWaveType.AlienShip, {
          amount: 1,
        }),
      )
      return waves
    },
  })

  register({
    type: EVoyageMissionType.FightAliens1,
    category: EVoyageMissionCategory.FightAliens,
    name: 'Eliminate Small Alien Squad',
    genMission: voyageMission_waves.generator_mission_waves,
    genWaves: () => {
      let waves: IVoyageMissionWave[] = []
      waves.push(
        voyageMissionDataWaves.create(EVoyageWaveType.BoardedByAliens, {
          amount: 2,
        }),
        voyageMissionDataWaves.create(EVoyageWaveType.BoardedByAliens, {
          amount: 3,
        }),
      )
      return waves
    },
  })
  register({
    type: EVoyageMissionType.FightAliens2,
    category: EVoyageMissionCategory.FightAliens,
    name: 'Eliminate Medium Alien Squad',
    genMission: voyageMission_waves.generator_mission_waves,
    genWaves: () => {
      let waves: IVoyageMissionWave[] = []
      waves.push(
        voyageMissionDataWaves.create(EVoyageWaveType.BoardedByAliens, {
          amount: 3,
        }),
        voyageMissionDataWaves.create(EVoyageWaveType.BoardedByAliens, {
          amount: 4,
        }),
        voyageMissionDataWaves.create(EVoyageWaveType.BoardedByAliens, {
          amount: 6,
        }),
      )
      return waves
    },
  })
  register({
    type: EVoyageMissionType.FightAliens3,
    category: EVoyageMissionCategory.FightAliens,
    name: 'Eliminate Large Alien Squad',
    genMission: voyageMission_waves.generator_mission_waves,
    genWaves: () => {
      let waves: IVoyageMissionWave[] = []
      waves.push(
        voyageMissionDataWaves.create(EVoyageWaveType.BoardedByAliens, {
          amount: 4,
        }),
        voyageMissionDataWaves.create(EVoyageWaveType.BoardedByAliens, {
          amount: 6,
        }),
        voyageMissionDataWaves.create(EVoyageWaveType.BoardedByAliens, {
          amount: 10,
        }),
      )
      return waves
    },
  })

  register({
    type: EVoyageMissionType.SurveyAnomaly,
    category: EVoyageMissionCategory.Survey,
    name: 'Survey Anomaly',
    scanTime: 30,
    // genMission: voyageMission_waves.generator_mission_waves,
  })

  register({
    type: EVoyageMissionType.SurveySun1,
    category: EVoyageMissionCategory.Survey,
    name: 'Survey Small Sun',
    scanTime: 30,
    // genMission: voyageMission_waves.generator_mission_waves,
  })

  register({
    type: EVoyageMissionType.SurveySun2,
    category: EVoyageMissionCategory.Survey,
    name: 'Survey Medium Sun',
    scanTime: 60,
    // genMission: voyageMission_waves.generator_mission_waves,
  })

  register({
    type: EVoyageMissionType.SurveySun3,
    category: EVoyageMissionCategory.Survey,
    name: 'Survey Supernova',
    scanTime: 90,
  })

  register({
    type: EVoyageMissionType.CombatZone1,
    category: EVoyageMissionCategory.CombatZone,
    name: 'Combat Zone 1',
    // scanTime: 90,
  })
}
